import Swiper, { Navigation } from 'swiper'

class Careers {
  constructor() {
    if (document.querySelector('.careers')) {
      this.Careers()
    }
  }

  Careers() {
    this.loadJobs()

    Swiper.use([Navigation])
    new Swiper('.careersLife__swiper', {
      navigation: {
        nextEl: '.careersLife__next',
        prevEl: '.careersLife__prev',
      },
      slidesPerView: 1.15,
      spaceBetween: 5,
      breakpoints: {
        763: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
      },
    })

    new Swiper('.careersHappiness__swiper', {
      navigation: {
        nextEl: '.careersHappiness__next',
        prevEl: '.careersHappiness__prev',
      },
      slidesPerView: 1,
      spaceBetween: 0,
    })
  }

  async loadJobs() {
    try {
      const url = 'https://api.ashbyhq.com/posting-api/job-board/withco'
      const rData = await fetch(url)
      const response = await rData.json()

      if (response && response.jobs && response.jobs.length > 0) {
        this.parseJobs(response.jobs)
      }
    } catch (err) {
      console.log(err)
    }
  }

  parseJobs(jobs) {
    let toLoad = parseInt(
      document.querySelector('.careersJobs').getAttribute('data-count')
    )
    for (let i = 0; i < toLoad; ++i) {
      const job = jobs[i]
      const markup = `
				<div class="careersJobs__itemCol">
					<h4 class="careersJobs__itemTitle">${job.title}</h4>
					<div class="careersJobs__itemLocation">${job.location}</div>
				</div>
				<div class="careersJobs__itemCol">
					<div class="careersJobs__itemCta">View Job →</div>
				</div>
			`

      const item = document.createElement('a')
      item.classList.add('careersJobs__item')
      item.innerHTML = markup
      item.setAttribute('href', job.jobUrl)
      item.setAttribute('target', '_blank')
      document.querySelector('.careersJobs__items').append(item)
    }
  }
}

export default Careers
